const API_KEY = "6d6d90e279735822958d05a8eabf1c15";
const API_URL = "https://api.themoviedb.org/3/";

const IMAGE_BASE_URL = "https://image.tmdb.org/t/p/";

const BACKDROP_SIZE = "w1280";

const POSTER_SIZE = "w500";

export { API_KEY, API_URL, IMAGE_BASE_URL, BACKDROP_SIZE, POSTER_SIZE };

// TODO:
// - Developing popular actors and actresses section(1 page for general, 1 page for detail: display list of that person's movies)
// Set vietnamese language
// https://developers.themoviedb.org/3/movies/get-top-rated-movies
// https://developers.themoviedb.org/3/movies/get-upcoming
// Actors and actresses /person/popular
// Get actor from a specific movie https://api.themoviedb.org/3/movie/{id}/credits?api_key=6d6d90e279735822958d05a8eabf1c15&language=en-US
// Use person_id from above and https://developers.themoviedb.org/3/people/get-person-details to get detail about actor
// Then use the creditId to get movies of that actor https://developers.themoviedb.org/3/credits/get-credit-details
// https://www.imdb.com/name/nm0147147/?ref_=nv_sr_srsg_0
